'use strict';

goog.provide("Ntry.JrEngineView");

Ntry.JrEngineView = function() {
	this._view = Ntry.interfaceManager.getDom('ntryEngine');

	Ntry.addEventListener("run", this, this.viewModeRun);
    Ntry.addEventListener("stop", this, this.viewModeStop);
    Ntry.addEventListener("replay", this, this.viewModeReplay);

    this.createDom();
};

(function(p){
	p.createDom = function () {
        var parent = this._view;
        this._engineButton = Ntry.createElement('button', parent, 'jrEngineButton',
                                'stopped');
        this._engineButton.innerHTML = Lang.Workspace.run;
        this._engineButton.bindOnClick(function(e){
            e.preventDefault();
            this.blur();
            Ntry.dispatchEvent('engineButtonClicked');
        });
    };

    p.viewModeRun = function () {
        var button = this.getPureButton();
        this._engineButton.innerHTML = Lang.Menus.engine_running;
        button.addClass('running');

        var stageId = Ntry.configManager.getConfig("stageId");
        var scripts = '';

        var entityManager = Ntry.entityManager;
        /*
        var entity = entityManager.getEntitiesByComponent(
            Ntry.STATIC.CODE);
        */
        var entities = entityManager.getEntitiesByComponent(
            Ntry.STATIC.CODE);

        var entity;
        for (var key in entities)
            var entity = entities[key];

        var code = entityManager.getComponent(entity.id, Ntry.STATIC.CODE).code;

        if (code) {
            var activity = new Entry.Activity('run', [[
                "code", code.stringify()
            ]]);
            Entry.activityReporter.add(activity);
            Ntry.dispatchEvent('saveLogs');
        }

    };

    p.viewModeStop = function () {
        var button = this.getPureButton();
        this._engineButton.innerHTML = Lang.Menus.start;
        button.addClass('stopped');
    };

    p.viewModeReplay = function () {
        var button = this.getPureButton();
        this._engineButton.innerHTML = Lang.Menus.engine_replay;
        button.addClass('end');
    };

    p.getPureButton = function() {
        this._engineButton.removeClasses();
        return this._engineButton;
    };

})(Ntry.JrEngineView.prototype);
